export default __webpack_public_path__ + "static/media/533.9a054eef.png";